import {Component, forwardRef, Input, OnInit, ElementRef, Output, EventEmitter} from '@angular/core';
import {NzFormatBeforeDropEvent, NzFormatEmitEvent, NzModalService, NzTreeNode} from 'ng-zorro-antd';
import {of, Observable} from 'rxjs';
import {delay} from 'rxjs/operators';
import {ExcelService} from "./excel.service";
import {HttpParams} from "@angular/common/http";
import {CacheService} from '@delon/cache';

/**
 * excel 导出
 */
@Component({
  selector: 'excel-output',
  templateUrl: './excel-output.component.html',
})

export class ExcelOutputComponent implements OnInit {
  @Input() isVisible:boolean;
  @Output() isVisibleChange = new EventEmitter();
  @Input() excelUrl:string;
  @Input() excelTitle:string;
  @Input() excelParam:HttpParams;
  //是否启用进度条,默认不启用
  @Input() enableProcess:boolean;

  isSpinning = false;

  percent = 0;
  processCode;

  ngOnInit():void {
    this.percent = 0;
    this.processCode = "processBarExcel" + (new Date()).getTime();
    this.isSpinning = false;
  }

  excelTitleNodes:any[] = [];

  constructor(private excelService:ExcelService, private srv:CacheService) {
    this.enableProcess = false;
  }

  /**
   * 获取可导出字段
   */
  getExcelTitle() {
    this.excelTitleNodes = [];
    this.excelService.getExcelTitle(this.excelUrl).subscribe((datas)=> {
      if (datas && datas.length > 0) {
        for (let i = 0; i < datas.length; i++) {
          let data = datas[i];
          let excelTitleNode = [];
          for (let j = 0; j < data.titleName.length; j++) {
            excelTitleNode.push(
              new NzTreeNode({
                title: (data.titleName)[j],
                isLeaf: true,
                key: "" + i + "-" + j,
                checked: true,
                children: []
              })
            )
          }
          let exceltilte = {
            sheetName: data.sheetName,
            titles: excelTitleNode
          };
          this.excelTitleNodes.push(exceltilte);
        }
      }
    });
  }

  mouseAction(name:string, e:NzFormatEmitEvent):void {
  }


  private changeProcess() {
    let returnProcent = this.srv.getNone(this.processCode);
    if (returnProcent) {
      this.percent = Number.parseInt('' + returnProcent);
    }
    if (this.isSpinning) {
      setTimeout(() => {
        this.changeProcess()
      }, 500);
    }
  }

  /**
   * 导出
   */
  private outPutExcel() {
    if (this.isSpinning) {
      return;
    }
    let outPutTitles = [];
    for (let i = 0; i < this.excelTitleNodes.length; i++) {
      let outPutTitle = [];
      let excelTitleNode = (this.excelTitleNodes)[i].titles;
      for (let j = 0; j < excelTitleNode.length; j++) {
        if (excelTitleNode[j].isChecked) {
          outPutTitle.push(excelTitleNode[j].title)
        }
      }
      outPutTitles.push(outPutTitle);
    }
    if (this.excelParam) {
      this.excelParam = this.excelParam.set("size", "65535").set("page", "0");
    }
    this.isSpinning = true;
    if (this.enableProcess) {
      this.srv.set(this.processCode, 0);
      this.percent = 0;
      this.changeProcess();
    }
    this.excelService.outPutExcel(this.excelUrl, outPutTitles, this.excelParam, this.processCode).subscribe((data)=> {
      this.isSpinning = false;
      if (data) {
        var a = document.createElement('a');
        var blob = new Blob([data], {'type': "application/vnd.ms-excel"});
        a.href = URL.createObjectURL(blob);
        a.download = this.excelTitle + ".xls";
        document.body.appendChild(a);
        a.click();
        this.handleCancel();
      }
    }, error => {
      this.isSpinning = false;
      this.handleCancel();
    });
  }

  /**
   * 关闭
   */
  handleCancel():void {
    this.isVisible = false;
    this.isVisibleChange.emit(false);
  }
}
